import Konva from 'konva';
import { useCanvasStageOperations } from 'state/canvas/stage';
import { Position } from 'types';
import useCanvas from 'components/canvas/hooks/use-canvas';

interface UseMiniMapOperations {
  translateMiniMapClickPositionToCanvas(miniMapStage: Konva.Stage): Position;
  translateToCanvasPosition(position: Position): Position;
  translateCanvasPositionToMiniMapPosition(
    position: Position,
    padding?: number,
  ): Position;
}

export default function useMiniMapOperations(
  surface: string,
): UseMiniMapOperations {
  const { getCanvasStage } = useCanvasStageOperations(surface);

  function translateMiniMapClickPositionToCanvas(
    miniMapStage: Konva.Stage,
  ): Position {
    const transform = miniMapStage?.getStage()?.getAbsoluteTransform().copy();

    const stage = getCanvasStage();

    transform.invert();

    const position = transform.point(
      miniMapStage.getStage().getPointerPosition() as any,
    );

    const widthOffset = (window.innerWidth * stage.scale) / 2;
    const heightOffset = (window.innerHeight * stage.scale) / 2;

    position.x = position.x * stage.scale - widthOffset;
    position.y = position.y * stage.scale - heightOffset;

    return {
      x: position.x !== 0 ? -position.x : position.x,
      y: position.y !== 0 ? -position.y : position.y,
    };
  }

  function translateToCanvasPosition(position: Position): Position {
    const stage = getCanvasStage();

    position.x = position.x * stage.scale;
    position.y = position.y * stage.scale;

    return {
      x: position.x !== 0 ? -position.x : position.x,
      y: position.y !== 0 ? -position.y : position.y,
    };
  }

  function translateCanvasPositionToMiniMapPosition(
    position: Position,
    padding: number = 0,
  ): Position {
    const stage = getCanvasStage();

    return {
      x: -position.x / stage.scale,
      y: -position.y / stage.scale,
    };
  }

  return {
    translateMiniMapClickPositionToCanvas,
    translateToCanvasPosition,
    translateCanvasPositionToMiniMapPosition,
  };
}
